export const STATUS_STYLES = {
  Published: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
  Review: "bg-amber-500/10 text-amber-400 border-amber-500/30",
  Draft: "bg-blue-500/10 text-blue-400 border-blue-500/30",
  Missing: "bg-rose-500/10 text-rose-400 border-rose-500/30",
};

export function StatusBadge({ status }) {
  return (
    <span className={`inline-block text-[10px] uppercase font-bold px-2 py-0.5 rounded-full border ${STATUS_STYLES[status] || STATUS_STYLES.Missing}`}>
      {status}
    </span>
  );
}
